/**
 * Phonics Review: Aa → Nn
 * 组合 PPT 有台词的 storySection，按字母顺序排列
 * 媒体文件直接引用原字母目录，不创建新媒体
 */

const MB_AA = '/media/phonics/aa';
const MB_EE = '/media/phonics/ee';
const MB_GG = '/media/phonics/gg';
const MB_HH = '/media/phonics/hh';
const MB_MM = '/media/phonics/mm';
const MB_NN = '/media/phonics/nn';

export const letterDataAaNN = {
  mediaBase: MB_AA, // 默认回退路径（instruction audio）

  storySections: [

    // ===== Aa — Story 1: Alligator =====
    {
      label: 'Aa - Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_AA}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_AA}/video_story_alligator.mp4?v1`, poster: `${MB_AA}/image17.png?v1` }],
      lines: [
        { en: 'Alligator has an ax.', cn: '鳄鱼有一把斧子。', audioEn: `${MB_AA}/story1_en_1.mp3?v1`, audioCn: `${MB_AA}/story1_cn_1.mp3?v1` },
        { en: 'Is this your ax?', cn: '这是你的斧子吗？', audioEn: `${MB_AA}/story1_en_2.mp3?v1`, audioCn: `${MB_AA}/story1_cn_2.mp3?v1` },
        { en: 'Yes, it is my ax.', cn: '是的，这是我的斧子。', audioEn: `${MB_AA}/story1_en_3.mp3?v1`, audioCn: `${MB_AA}/story1_cn_3.mp3?v1` },
      ],
    },

    // ===== Aa — Story 2: Ant =====
    {
      label: 'Aa - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_AA}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_AA}/video_story_ant.mp4?v1`, poster: `${MB_AA}/image18.png?v1` }],
      lines: [
        { en: 'Ant has an apple.', cn: '蚂蚁有一个苹果。', audioEn: `${MB_AA}/story2_en_1.mp3?v1`, audioCn: `${MB_AA}/story2_cn_1.mp3?v1` },
        { en: 'Is this your apple?', cn: '这是你的苹果吗？', audioEn: `${MB_AA}/story2_en_2.mp3?v1`, audioCn: `${MB_AA}/story2_cn_2.mp3?v1` },
        { en: 'Yes, it is my apple.', cn: '是的，这是我的苹果。', audioEn: `${MB_AA}/story2_en_3.mp3?v1`, audioCn: `${MB_AA}/story2_cn_3.mp3?v1` },
      ],
    },

    // ===== Ee — Story 1: Where are my eggs? =====
    {
      label: 'Ee - Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_EE}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_EE}/Ee_1.mp4?v1`, poster: `${MB_EE}/image15.png?v1` }],
      lines: [
        { en: 'Where are my eggs?', cn: '我的蛋在哪里？', audioEn: `${MB_EE}/story1_en_1.mp3?v1`, audioCn: `${MB_EE}/story1_cn_1.mp3?v1` },
      ],
    },

    // ===== Ee — Story 2: Did you see my eggs? =====
    {
      label: 'Ee - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_EE}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_EE}/Ee_2.mp4?v1`, poster: `${MB_EE}/image16.png?v1` }],
      lines: [
        { en: 'Did you see my eggs?', cn: '你看到我的蛋了吗？', audioEn: `${MB_EE}/story2_en_1.mp3?v1`, audioCn: `${MB_EE}/story2_cn_1.mp3?v1` },
        { en: "No, I didn't.", cn: '不，我没看到。', audioEn: `${MB_EE}/story2_en_2.mp3?v1`, audioCn: `${MB_EE}/story2_cn_2.mp3?v1` },
      ],
    },

    // ===== Gg — Story 1: Goat =====
    {
      label: 'Gg - Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_GG}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_GG}/video_story_goat.mp4?v2`, poster: `${MB_GG}/image14.png?v2` }],
      lines: [
        { en: 'Goat is chewing gum.', cn: '山羊在嚼口香糖', audioEn: `${MB_GG}/story1_en_1.mp3?v2`, audioCn: `${MB_GG}/story1_cn_1.mp3?v2` },
        { en: 'Goat likes bubble gum.', cn: '山羊喜欢嚼泡泡糖', audioEn: `${MB_GG}/story1_en_2.mp3?v2`, audioCn: `${MB_GG}/story1_cn_2.mp3?v2` },
      ],
    },

    // ===== Hh — Story 1: Hen =====
    {
      label: 'Hh - Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_HH}/audio_instruction_repeat.mp3`,
      videos: [{ src: `${MB_HH}/video_story_hen.mp4?v1`, poster: `${MB_HH}/image18.png?v1` }],
      lines: [
        { en: 'Hen is hiding under the hat.', cn: '母鸡正藏在帽子下面。', audioEn: `${MB_HH}/story1_en_1.mp3?v1`, audioCn: `${MB_HH}/story1_cn_1.mp3?v1` },
        { en: 'Where is hen?', cn: '母鸡在哪里？', audioEn: `${MB_HH}/story1_en_2.mp3?v1`, audioCn: `${MB_HH}/story1_cn_2.mp3?v1` },
        { en: 'I found you, Hen.', cn: '我找到你了，母鸡。', audioEn: `${MB_HH}/story1_en_3.mp3?v1`, audioCn: `${MB_HH}/story1_cn_3.mp3?v1` },
      ],
    },

    // ===== Mm — Story 1: Monkey is cold =====
    {
      label: 'Mm - Learn the Story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `${MB_MM}/audio_instruction_repeat.mp3`,
      videos: [{
        src: `${MB_MM}/story_mm1.mp4?v1`,
        poster: `${MB_MM}/image11.png?v1`,
      }],
      splitAt: 2,
      lines: [
        { en: 'Monkey is cold.', cn: '猴子冷', cnNewLine: true, audioEn: `${MB_MM}/story1_en_3.mp3?v1`, audioCn: `${MB_MM}/story1_cn_3.mp3?v1` },
        { en: 'cold', cn: '冷', audioEn: `${MB_MM}/w_en_cold.mp3?v1`, audioCn: `${MB_MM}/w_cn_cold.mp3?v1` },
        { en: 'What do I have?', cn: '我有什么呢？', cnNewLine: true, audioEn: `${MB_MM}/story1_en_1.mp3?v1`, audioCn: `${MB_MM}/story1_cn_1.mp3?v1` },
        { en: 'have', cn: '有', audioEn: `${MB_MM}/w_en_have.mp3?v1`, audioCn: `${MB_MM}/w_cn_have.mp3?v1` },
        { en: 'I have', cn: '我有', audioEn: `${MB_MM}/s_en_ihave.mp3?v1`, audioCn: `${MB_MM}/s_cn_ihave.mp3?v1` },
        { en: 'Do I have ?', cn: '我有...吗？', audioEn: `${MB_MM}/s_en_dohave.mp3?v1`, audioCn: `${MB_MM}/s_cn_dohave.mp3?v1` },
        { en: 'do ?', cn: '表示疑问', audioEn: `${MB_MM}/s_en_do_question.mp3?v1`, audioCn: `${MB_MM}/s_cn_do_question.mp3?v1` },
      ],
    },

    // ===== Mm — Story 2: I have my mittens =====
    {
      label: 'Mm - Learn the Story (2)',
      headerTitle: 'Mm - Learn the Story (2)',
      layout: 'text-repeat-table',
      instructionAudio: `${MB_MM}/audio_instruction_repeat.mp3`,
      groups: [
        {
          rows: [
            { en: 'I have my mittens.', cn: '我有我的手套', audioEn: `${MB_MM}/s_en_ihavemittens.mp3?v1`, audioCn: `${MB_MM}/s_cn_ihavemittens.mp3?v1` },
            { en: 'Do I have mittens?', cn: '我有手套吗？', audioEn: `${MB_MM}/story2_en_1.mp3?v1`, audioCn: `${MB_MM}/story2_cn_1.mp3?v1` },
            { en: "Oh, that's better.", cn: 'Oh, 那样更好', audioEn: `${MB_MM}/story2_en_2.mp3?v1`, audioCn: `${MB_MM}/story2_cn_2.mp3?v1` },
            { en: 'better', cn: '更好', audioEn: `${MB_MM}/w_en_better.mp3?v1`, audioCn: `${MB_MM}/w_cn_better.mp3?v1` },
            { en: 'that', cn: '那样', audioEn: `${MB_MM}/w_en_that.mp3?v1`, audioCn: `${MB_MM}/w_cn_that.mp3?v1` },
          ],
        },
      ],
    },

    // ===== Nn — Story 2: nine eggs / Naughty Ned =====
    {
      label: 'Nn - Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      instructionAudio: `${MB_NN}/audio_instruction_repeat.mp3`,
      videos: [{
        src: `${MB_NN}/video_story_nest.mp4?v1`,
      }],
      lines: [
        { en: 'There are nine eggs.', cn: '那里有9个鸡蛋。', audioEn: `${MB_NN}/story2_en_1.mp3?v1`, audioCn: `${MB_NN}/story2_cn_1.mp3?v1` },
        { en: 'Hey stop. Naughty Ned.', cn: '嘿，停下。淘气的 Ned。', audioEn: `${MB_NN}/story2_en_2.mp3?v1`, audioCn: `${MB_NN}/story2_cn_2.mp3?v1` },
        { en: 'No, no. I want this nest.', cn: '不不。我想要这个鸟巢。', audioEn: `${MB_NN}/story2_en_3.mp3?v1`, audioCn: `${MB_NN}/story2_cn_3.mp3?v1` },
      ],
    },

  ],
};

export default letterDataAaNN;
